import React from 'react';

import { UserContext, useUserData } from './auth';
import { SearchProvider } from './search';
import { UserInfoProvider } from './userinfo';

const AppProvider: React.FC = ({ children }) => {
  const userData = useUserData();

  return (
    <UserContext.Provider value={userData}>
      <UserInfoProvider>
        <SearchProvider>{children}</SearchProvider>
      </UserInfoProvider>
    </UserContext.Provider>
  );
};

export default AppProvider;
